// Data access + row normalization for GET /admin/clients consumers (the
// clients list page and the admin shell's breadcrumb/context list).
import type { ApiClient } from "./api";
import type { AdminClient } from "./outlet-context";

export function deriveLifecycle(client: AdminClient): string {
  const allDone =
    client.d1_database_id &&
    client.assets_bucket_name &&
    client.pages_project_name &&
    client.domain_mapped;
  const anyDone =
    client.d1_database_id ||
    client.assets_bucket_name ||
    client.pages_project_name ||
    client.domain_mapped;
  if (allDone) return "Active";
  if (anyDone) return "Provisioning";
  return "Draft";
}

export function normalizeClient(raw: AdminClient): AdminClient {
  return {
    ...raw,
    name: raw.business_name ?? raw.id,
    billingStatus: raw.billing_status,
    lifecycle: deriveLifecycle(raw),
    domain_mapped: !!raw.domain_mapped,
  };
}

export interface ClientsPageResult {
  clients: AdminClient[];
  schemaLatest: number;
  total: number;
}

/** Paged clients list; `query` is a list-controls query string ("" = all). */
export async function fetchClientsPage(api: ApiClient, query = ""): Promise<ClientsPageResult> {
  const data = await api.request<{ clients?: AdminClient[]; schema_latest?: number; total?: number }>(
    `/admin/clients${query ? `?${query}` : ""}`
  );
  const clients = (data.clients ?? []).map(normalizeClient);
  return {
    clients,
    schemaLatest: data.schema_latest ?? 0,
    total: data.total ?? clients.length,
  };
}
